import React from "react";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Chip,
  Container,
  FormControlLabel,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import SelectApiInput from "../../../../components/common/input/SelectApiInput";
import { MOBILE_CONTAINER } from "../../../../utils/ui.constants";
import { LuSearch } from "react-icons/lu";
import { generateLinkImage, numeralCustom } from "../../../../utils/helpers";
import Number from "../details/detail/Number";
import { useOrderContext } from "../../OrderPage";
import { useSelector } from "react-redux";
import { cloneDeep } from "lodash";

function Search() {
  const { currentHd } = useSelector((state: any) => state.order);
  const {
    selectMulti,
    originHd,
    setSelectMulti,
    handleAddProductToDetails,
    handleUpdateCurrentHd,
  } = useOrderContext();

  const handleSelect = (val: any) => {
    handleAddProductToDetails({
      product: val,
      gia_ban_le: val?.gia_ban_le,
      ma_dvt: val?.ma_dvt,
      ten_dvt: val?.ten_dvt,
    });
  };

  const handleNumberChange = (data: any, number: number) => {
    const newNumber = number < 1 ? 1 : number;
    const currentHdClone = cloneDeep(currentHd);
    const index = currentHdClone.details.findIndex(
      (d: any) => d._id === data._id
    );
    if (index < 0) return;
    const detail = currentHdClone.details[index];
    detail.sl_order = newNumber;
    // detail.sl_gui_bep = detail.sl_order;
    const tienCk: number =
      Math.floor(
        ((detail.ty_le_ck || 0) * (detail.gia_ban_le_goc || 0)) / 100
      ) * detail.sl_order;
    detail.tien_ck_nt = tienCk;
    handleUpdateCurrentHd({ details: currentHdClone.details });
  };

  const handleReset = () => {
    handleUpdateCurrentHd({ details: originHd?.details || [] });
  };

  return (
    <Box>
      <SelectApiInput
        useDrawer
        closeOnSelect={!selectMulti}
        direction="column"
        apiCode="dmvt"
        defaultCondition={{
          sp_yeu_cau_che_bien: true,
          sp_yeu_cau_pha_che: true,
        }}
        searchFields={["ma_vt", "ten_vt"]}
        checkEqual={(value, option) => value?.ma_vt === option?.ma_vt}
        getOptionLabel={(option) => option.ten_vt}
        placeholderSearch="Tìm theo mã, tên món"
        placeholder="Chọn món"
        fixedScrollHeight={
          selectMulti
            ? `calc(100vh - 50px - 1px - 40px - 45px)`
            : `calc(100vh - 50px - 1px - 40px)`
        }
        renderDisplay={({ value, onClick }) => {
          return (
            <Box
              sx={{
                width: "100%",
                backgroundColor: "background.paper",
              }}
            >
              <Container maxWidth={MOBILE_CONTAINER} sx={{ width: "100%" }}>
                <Stack
                  component={MenuItem}
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%", height: "45px", padding: 0 }}
                  onClick={onClick}
                >
                  <LuSearch size={20} />
                  <Typography
                    sx={{
                      flex: 1,
                      lineHeight: "45px",
                      color: "text.secondary",
                    }}
                  >
                    {!!value ? value?.ten_vt : "Chọn món"}
                  </Typography>
                </Stack>
              </Container>
            </Box>
          );
        }}
        onChange={handleSelect}
        renderOption={(option, { key, isEqual, onClick }) => {
          const existed = (currentHd?.details || []).find(
            (item: any) => item.ma_vt === option.ma_vt
          );
          return (
            <Stack
              key={key}
              onClick={!!existed ? undefined : onClick}
              component={MenuItem}
              sx={{
                width: "100%",
                py: 1,
                borderTop: "1px dashed",
                borderColor: "divider",
                backgroundColor: !!existed ? "primary.500" : "",
                "&:first-of-type": {
                  borderTop: "none",
                },
              }}
            >
              <Stack
                sx={{ width: "100%" }}
                direction="row"
                alignItems="center"
                gap={2}
              >
                <Avatar
                  src={generateLinkImage(option.picture_thumb)}
                  alt="product image"
                  sx={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "10px",
                    border: "1px dashed",
                    borderColor: "primary.main",
                  }}
                />
                <Stack sx={{ flex: "1" }}>
                  <Stack direction="row" alignItems="center" gap={1}>
                    <Typography>{option.ten_vt}</Typography>
                    <Chip
                      size="small"
                      variant="outlined"
                      color="primary"
                      label={option.ten_dvt || option.ma_dvt}
                    />
                  </Stack>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography
                      sx={{
                        width: "50%",
                        fontWeight: 500,
                        color: "error.main",
                      }}
                    >
                      {numeralCustom(option.gia_ban_le).format()} đ
                    </Typography>
                    {selectMulti && !!existed && (
                      <Number
                        defaultValue={existed?.sl_order}
                        onNumberChange={(val) =>
                          handleNumberChange(existed, val)
                        }
                      />
                    )}
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          );
        }}
        renderTopList={() => {
          return (
            <Container maxWidth={MOBILE_CONTAINER}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  borderBottom: "1px solid",
                  borderColor: "divider",
                  height: "40px",
                  px: 2,
                }}
              >
                <FormControlLabel
                  label="Chọn nhiều"
                  checked={selectMulti}
                  onChange={(_, checked) => {
                    setSelectMulti(checked);
                  }}
                  control={<Checkbox size="small" />}
                />
              </Stack>
            </Container>
          );
        }}
        renderBottom={
          selectMulti
            ? ({ onClose }) => {
                return (
                  <Box>
                    <Container maxWidth="sm">
                      <Stack direction="row" alignItems="center">
                        <Box sx={{ width: "50%" }}>
                          <Button
                            onClick={handleReset}
                            fullWidth
                            size="small"
                            variant="contained"
                            color="secondary"
                            sx={{
                              height: "45px",
                              boxShadow: "none",
                              borderRadius: "0px",
                              "&:hover": { boxShadow: "none" },
                            }}
                          >
                            Chọn lại
                          </Button>
                        </Box>
                        <Box sx={{ width: "50%" }}>
                          <Button
                            onClick={onClose}
                            fullWidth
                            size="small"
                            variant="contained"
                            color="primary"
                            sx={{
                              height: "45px",
                              boxShadow: "none",
                              borderRadius: "0px",
                              color: "common.white",
                              "&:hover": { boxShadow: "none" },
                            }}
                          >
                            Xong
                          </Button>
                        </Box>
                      </Stack>
                    </Container>
                  </Box>
                );
              }
            : undefined
        }
      />
    </Box>
  );
}

export default Search;
